export default class subscriberFormHtmlGenerator {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                subscriberForm: '&'
            },
            template: require('../../../../views/subscriber/subscriberForm/generatedHtml.html'),
            replace: true,
            controller: HtmlGenerator,
            controllerAs: 'generator'
        }
    }
};

class HtmlGenerator {
    constructor($scope, $filter) {
        this._scope = $scope;
        this._translator = $filter('translate');
        this.directCopySupported = document.queryCommandSupported('copy');
        this.generate();
    }

    static idToFieldTypeName(id) {
        let idToNameMap = {
            1: 'text',
            2: 'single',
            3: 'multiple',
            4: 'json',
            5: 'datetime',
            6: 'date',
            7: 'time'
        };

        return idToNameMap[id] ? idToNameMap[id] : 'text';
    }

    getStyles() {
        let styles = '<style>';
        if (this._scope.subscriberForm().recaptcha) styles += '.grecaptcha-badge {display: none}';
        styles += '.rulemailer-subscriber-form {font-family: Helvetica, sans-serif;width: 500px;}';
        styles += '.rulemailer-subscriber-form input {display: block;width: 100%;margin: 5px 0 10px 0;border: 0px solid #f2f2f5 !important;background: #f2f2f5 !important;font-size: 14px;padding: 10px;outline: none !important;resize: none;}';
        styles += '.rulemailer-subscriber-form input[type=\'checkbox\'] {display: inline-block;width: auto;margin-right: 10px;}';
        styles += '.rulemailer-subscriber-form button {display: block;margin-top: 20px; background: #262950;color: #fff;line-height: 1.33;font-size: 14px;padding: 8px 23px;height: 37px;cursor: pointer; border: 2px solid #262950; border-radius: 7px;}';
        styles += '.rulemailer-subscriber-form button:hover {background: transparent; color: #262950}';
        // Honey pot
        styles += '.rulemailer-email-check {display: none !important;}';
        styles += '</style>';

        return styles;
    }

    generateTags(tags) {
        let tagInput = '';

        angular.forEach(tags, (tag) => {
            tagInput += '<input type="hidden" value="' + tag.id + '" name="tags[]">';
        });

        return tagInput;
    }

    generateTokenInput() {
        return '<input type="hidden" name="token" value="' + this._scope.subscriberForm().token + '">';
    }

    generate() {
        let formString = this.getStyles();

        if (this._scope.subscriberForm().recaptcha) formString += '<script src="https://www.google.com/recaptcha/api.js" async defer></script>';
        formString += '<div class="rulemailer-subscriber-form">';
        formString += '<form id="rule-optin-form" action="https://app.rule.io/subscriber-form/subscriber" method="POST">';

        formString += this.generateTags(this._scope.subscriberForm().tags);
        formString += this.generateTokenInput(this._scope.subscriberForm().token);

        angular.forEach(this._scope.subscriberForm().fields, (element) => {
            var label = '<label>' + element.label + '</label>';

            var input = $('<input type="' + this.constructor.idToFieldTypeName(element.custom_field_type_id) + '" placeholder="' + element.label + '" name="fields[' + element.field_identifier + ']">')

            if (element.field_identifier === 'rule_email' || element.field_identifier === 'email') {
                input = $('<input type="email" placeholder="' + element.label + '" name="' + element.field_identifier + '">');
            }

            if (element.field_identifier === 'phone_number') {
                input = $('<input type="text" placeholder="' + element.label + '" name="' + element.field_identifier + '">');
            }

            if (element.required === true) {
                input.attr('required', true);
            }

            formString += label;
            formString += input[0].outerHTML;
        });

        if (this._scope.subscriberForm().confirmation.text || this._scope.subscriberForm().confirmation.link.url) {
            formString += '<div>';
            formString += '<input type="checkbox" name="confirmation" required>';
            formString += '<span>' + this._scope.subscriberForm().confirmation.text + ' ' + '</span>';

            if (this._scope.subscriberForm().confirmation.link.url) {
                formString += '<a href="' + this._scope.subscriberForm().confirmation.link.url + '" target="_blank">' + (this._scope.subscriberForm().confirmation.link.description ? this._scope.subscriberForm().confirmation.link.description : this._scope.subscriberForm().confirmation.link.url) + '</a>';
            }

            formString += '</div>';
        }

        // Honey pot
        formString += '<label class="rulemailer-email-check">Are you machine?</label>';
        formString += '<input type="checkbox" name="email_field" class="rulemailer-email-check" value="1" tabindex="-1" autocomplete="off">';

        // Append language
        formString += '<input type="hidden" name="language" value="' + this._scope.subscriberForm().language.code + '">';

        if (this._scope.subscriberForm().recaptcha) {
            formString += `<button class="g-recaptcha" data-sitekey="${this._scope.subscriberForm().recaptcha_site_key}" data-callback='submitRuleOptin'>${this._translator('GLOBAL:SEND')}</button></form></div><script>function submitRuleOptin(token) {document.getElementById("rule-optin-form").submit();}</script>`;
        } else {
            formString += `<button type="submit">${this._translator('GLOBAL:SEND')}</button></form></div>`;
        }

        this.generatedHtml = formString;
    }
}
